package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.ComponentVariant
import com.varabyte.kobweb.silk.components.style.addVariant
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val NavItemStyle by ComponentStyle {
    val sitePalette = colorMode.toSitePalette()
    val itemColor = sitePalette.onBackground.let {
        if (colorMode.isLight)
            it.lightened(0.5f)
        else
            it.darkened(0.5f)
    }
    cssRule(" svg path") {
        Modifier.styleModifier {
            property("fill", itemColor)
        }
            .transition(
                CSSTransition(
                    TransitionProperty.All,
                    duration = 300.ms
                )
            )
    }
    cssRule(":hover svg path") {
        Modifier.styleModifier {
            property("fill", sitePalette.brand.primary)
        }
    }
    cssRule(" span") {
        Modifier.color(itemColor)
            .transition(
                CSSTransition(
                    TransitionProperty.All,
                    duration = 300.ms
                )
            )
    }

    cssRule(":hover span") {
        Modifier.translateX(4.px)
            .color(sitePalette.onBackground)
    }
}

val LogoutIconColorVariant by NavItemStyle.addVariant {
    cssRule(" svg path") {
        Modifier.styleModifier {
            property("fill", Colors.Red)
        }
    }
}

val NavItemActiveVariant by NavItemStyle.addVariant {
    val sitePalette = colorMode.toSitePalette()
    cssRule(" span") {
        Modifier.color(sitePalette.onBackground)
    }
    cssRule(" svg path") {
        Modifier.styleModifier {
            property("fill", sitePalette.brand.primary)
        }
    }
}

@Composable
fun NavItem(
    image: String,
    title: String,
    color: Color? = null,
    variant: ComponentVariant? = null,
    onClick: () -> Unit = {},
) {
    Row(
        modifier = Modifier.gap(20.px)
            .fillMaxWidth()
            .then(NavItemStyle.toModifier(variant)).cursor(Cursor.Pointer).onClick {
                onClick()
            }
            .padding(topBottom = 10.px),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        SvgLoader(
            image, modifier = Modifier.size(24.px),
            color = color
        )
        SpanText(title, modifier = Modifier.fontSize(16.px))
    }
}